import React, { Component } from 'react';
import { gsap } from 'gsap';
import ReactDOM from 'react-dom';

import API from '@api';
import config from '@config';

const Card = ({ program, channel }) => {
  if (program && channel) {
    const programLink = program?.player_links?.web?.live_stream
      ? program.player_links.web.live_stream
      : program.player_links.tv.program_url;

    return (
      <li className="fv-card-slider__card">
        <a href={programLink} target="_blank" rel="noopener">
          <div
            className="fv-card-slider__card__bg"
            style={
              program.image_url
                ? {
                    backgroundImage: `url(${program.image_url}?w=${config.programCardImageWidth})`,
                  }
                : {}
            }
          />
          <img
            className="fv-card-slider__card__logo"
            src={`${channel.service_image}?w=${config.channelImageWidth}`}
            alt={channel.title}
            loading="lazy"
          />
          <div className="fv-card-slider__card__infos">
            {program.secondary_title && <span>{program.secondary_title}</span>}
            <h6>{program.main_title}</h6>
          </div>
          <div className="fv-card-slider__card__on-air" />
        </a>
      </li>
    );
  }
  return null;
};

const PromoCard = ({
  text,
  backgroundColor,
  backgroundImage,
  link,
  linkTarget,
  linkText,
}) => {
  return (
    <div
      className={`fv-card-slider__promo fv-card-slider__promo--${backgroundColor}${
        !backgroundImage ? ' fv-card-slider__promo--no-bg' : ''
      }
       `}
    >
      <a href={link} target={linkTarget} rel="noopener">
        {backgroundImage && (
          <div
            className="fv-card-slider__card__bg"
            style={
              backgroundImage
                ? {
                    backgroundImage: `url(${backgroundImage})`,
                  }
                : {}
            }
          />
        )}
        <div
          className="fv-card-slider__card__infos fv-card-slider__card__infos--promo"
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <div className="fv-card-slider__card__infos fv-card-slider__card__infos--read-more fv-link--chevron">
          {linkText}
        </div>
      </a>
    </div>
  );
};

class ProgramHightlight extends Component {
  constructor(props) {
    super(props);

    this.state = {
      programs: [],
      isScrolling: false,
    };

    this.onMouseMove = this.onMouseMove.bind(this);
  }

  componentDidMount() {
    this.handleUpdate();
    this.updateInterval = setInterval(
      this.handleUpdate.bind(this),
      config.programHighlightUpdateInterval,
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isScrolling !== this.state.isScrolling) {
      this.toggleScrolling(this.state.isScrolling);
    }

    if (this.props.nid !== prevProps.nid) {
      this.handleUpdate();
      this.updateInterval = setInterval(
        this.handleUpdate.bind(this),
        config.programHighlightUpdateInterval,
      );
    }
  }

  handleUpdate() {
    switch (this.props.railType) {
      case 'on_now':
        API.getWhatsOn(this.props.nid)
          .then(programs => {
            this.setState({
              programs: programs.filter(p => p.now_next == 'now'),
            });
          })
          .catch(error => {
            console.error(error);
          });
        break;
      case 'on_demand':
        API.getProgramRecommendations(this.props.railCategory, this.props.nid)
          .then(programs => {
            this.setState({ programs: programs });
          })
          .catch(error => {
            console.error(error);
          });
        break;
      case 'boxsets':
        API.getBoxSets(this.props.railCategory, this.props.nid)
          .then(programs => {
            this.setState({ programs: programs });
          })
          .catch(error => {
            console.error(error);
          });
        break;
      default:
        API.getWhatsOn(this.props.nid)
          .then(programs => {
            this.setState({
              programs: programs.filter(p => p.now_next == 'now'),
            });
          })
          .catch(error => {
            console.error(error);
          });
        break;
    }
  }

  toggleScrolling(isEnable) {
    if (isEnable) {
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp.bind(this));
    } else {
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
    }
  }

  onMouseMove(event) {
    const { clientX, scrollLeft, scrollTop, clientY } = this.state;
    this._scroller.scrollLeft = scrollLeft - clientX + event.clientX;
    this._scroller.scrollTop = scrollTop - clientY + event.clientY;
  }

  onMouseUp(e) {
    this.setState({
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0,
      clientX: 0,
      clientY: 0,
    });
  }

  onMouseDown(event) {
    const { scrollLeft, scrollTop } = this._scroller;
    this.setState({
      isScrolling: true,
      scrollLeft,
      scrollTop,
      clientX: event.clientX,
      clientY: event.clientY,
    });
  }

  attachScroller(scroller) {
    this._scroller = ReactDOM.findDOMNode(scroller);
  }

  handleNavClick(direction) {
    const elWidth = this._scroller.children[3].clientWidth;
    const distance = direction > 0 ? elWidth : elWidth * -1;
    gsap.to(this._scroller, 0.5, {
      scrollLeft: this._scroller.scrollLeft + distance,
    });
  }

  render() {
    return (
      <div className="fv-card-slider">
        <h3>{this.props.title ? this.props.title : 'Watch now'}</h3>
        <div className="fv-card-slider__nav fv-carousel">
          <div
            className="fv-card-slider__nav__cta fv-card-slider__nav__cta--left"
            onClick={this.handleNavClick.bind(this, -1)}
          >
            <span className="fv-directional-cta fv-directional-cta--left" />
          </div>
          <div
            className="fv-card-slider__nav__cta fv-card-slider__nav__cta--right"
            onClick={this.handleNavClick.bind(this, 1)}
          >
            <span className="fv-directional-cta fv-directional-cta--right" />
          </div>
        </div>
        <ul
          className="fv-card-slider__container"
          ref={this.attachScroller.bind(this)}
          onMouseDown={this.onMouseDown.bind(this)}
        >
          <li className="fv-card-slider__card fv-card-slider__card--hidden visible-mobile" />
          <li className="fv-card-slider__card fv-card-slider__card--promo">
            {drupalSettings.tvguide_watch_now_banner && (
              <PromoCard
                text={drupalSettings.tvguide_watch_now_banner.text}
                backgroundImage={
                  drupalSettings.tvguide_watch_now_banner.background_image
                }
                backgroundColor={
                  drupalSettings.tvguide_watch_now_banner.background_colour
                }
                linkTarget={drupalSettings.tvguide_watch_now_banner.link_target}
                link={drupalSettings.tvguide_watch_now_banner.link}
                linkText={drupalSettings.tvguide_watch_now_banner.link_text}
              />
            )}
          </li>
          {this.state.programs.map(p => (
            <Card
              program={p}
              channel={this.props.channels.find(
                c => c.service_id == p.service_id,
              )}
              openDetailPanel={this.props.openDetailPanel}
              key={`hightlight-${p.uuid}`}
            />
          ))}
          <li className="fv-card-slider__card fv-card-slider__card--hidden" />
        </ul>
      </div>
    );
  }
}

export default ProgramHightlight;
